import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/Generic/NavBar";
import ToastMessage from "./components/Generic/ToastMessage";
import Home from "./pages/Home";
import About from "./pages/About";
import Directory from "./pages/Directory";
import Mentorship from "./pages/MentorShip";
import Gallery from "./pages/Gallery";
import EventsList from "./components/Event/EventsList"; // Events list
import Events from "./pages/Events"; // Single event details
import Forum from "./pages/CommunityForum";
import Referral from "./pages/Referral";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import ContactPage from "./pages/ContactUs";
import VerifyEmail from "./components/Registration/VerifyEmail";
import ResetPassword from "./components/Registration/ResetPassword";
import ProfilePage from "./components/Profile/ProfilePage";
import Blogs from "./pages/Blogs";
import MemberProfile from "./components/Profile/MemberProfile";
import Footer from "./components/Generic/Footer";
// import PrivacyPolicy from "./pages/PrivacyPolicy";
import Cookies from "./components/Generic/Cookies";
import NotFound from "./pages/NotFound";
import CompleteGoogleProfileForm from "./components/Registration/CompleteProfile";
import BlogDetails from "./components/BlogPosts/BlogDetails";
// import LinkedInCallback from "./components/Registration/LinkedinCallback";

// ScrollToTop component triggers scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <div className="app-container d-flex flex-column min-vh-100">
      <NavBar />

      {/* ScrollToTop will run on every route change */}
      <ScrollToTop />

      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          {<Route path="*" element={<NotFound />} />}
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/:eventId" element={<Events />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/mentorship" element={<Mentorship />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contactus" element={<ContactPage />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/verify" element={<VerifyEmail />} />
          {/* <Route path="/resend-verification" element={<VerifyEmail />} /> */}
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/members/:id" element={<MemberProfile />} />
          <Route
            path="/auth/google/callback"
            element={<CompleteGoogleProfileForm />}
          />

          {/* <Route
            path="/auth/linkedin/callback"
            element={<LinkedInCallback />}
          /> */}
          {/* {
            <Route
              path="/privacypolicy"
              element={<PrivacyPolicy></PrivacyPolicy>}
            />
          } */}
        </Routes>
      </main>

      <ToastMessage />
      <Cookies></Cookies>
      <Footer />
    </div>
  );
};

export default App;
